export const generateOrganizationName = (email: string): string => {
    const normalizedEmail = email.trim();

    if (!normalizedEmail) {
        throw new Error("Email is required");
    }

    const [name] = normalizedEmail.split("@");

    if (!name) {
        throw new Error("Invalid email address");
    }

    return `${name.charAt(0).toUpperCase()}${name.slice(1)}'s Organization`;
};